export interface Command<TKey extends string = string, T = unknown> {
  name: TKey;
  payload: T;
}

export const CommandHandlerFactorySymbol = Symbol.for('StoreCommandHandlerFactory');
export const CommandHandlerSymbol = Symbol.for('StoreCommandHandler');

export interface CommandHandler<T> {
  execute(command: T extends Command<string, infer X> ? X : never): Promise<void>;
}


export function createCommand<T>(
  name: T extends Command<infer X, any> ? X : never,
  payload: T extends Command<string, infer X> ? X : never):
    Command<T extends Command<infer X, any> ? X : never, T extends Command<string, infer X> ? X : never> {
  return {
    name,
    payload
  };
}
